import appleWatchDock from '@/assets/device-icons/apple-watch-dock.svg';

interface AppleWatchDockIconProps {
  className?: string;
}

export const AppleWatchDockIcon = ({ className = "h-5 w-5" }: AppleWatchDockIconProps) => {
  return (
    <img 
      src={appleWatchDock} 
      alt="Apple Watch Dock" 
      className={className}
    />
  );
};
